import { render, staticRenderFns } from "./qInputMultipleLanguage.vue?vue&type=template&id=2b2efe60&"
import script from "./qInputMultipleLanguage.vue?vue&type=script&lang=ts&"
export * from "./qInputMultipleLanguage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports